import { toPlace } from '@data/api/mappers/places/toPlace'
import { requester, RequestInfo } from '@data/api/requester'
import { fifteenMinutes } from '@data/constants/time'
import { QueryOptions } from '@data/queries/types'
import { QueryKey, skipToken, useQuery, UseQueryResult } from '@tanstack/react-query'

const locationSuggestionPlaceRequest = (placeId: TPlace['placeId']): RequestInfo<TPlace> => ({
    method: 'GET',
    url: `/location/suggestion/${placeId}`,
    params: {
        sessionToken: placeId,
    },
    responseMapper: toPlace,
})

const getQueryKey = (placeId?: TPlace['placeId']): QueryKey => ['location-suggestion', { placeId: placeId ?? null }]

export const useLocationSuggestionPlace = (
    placeId?: TPlace['placeId'],
    options?: QueryOptions<TPlace, ApiError>
): UseQueryResult<TPlace, ApiError> => {
    const queryKey = getQueryKey(placeId)
    const enabled = typeof placeId !== 'undefined' && placeId.length > 0 && options?.enabled !== false
    const queryFn = enabled ? () => requester(locationSuggestionPlaceRequest(placeId)) : skipToken

    return useQuery({
        staleTime: Infinity,
        gcTime: fifteenMinutes,
        ...options,
        queryKey,
        queryFn,
        enabled,
    })
}
